import { RoutingRuleTriggerType } from '@mews-commander/data-access';
import { Redirect } from '@mews-commander/ui';
import { useRoutingRulesData } from '../queries';
import { RoutingRulesStepsView } from './RoutingRulesStepsView';

export const RoutingRulesEditView = ({
    routingRuleId,
    enterpriseId,
}: {
    routingRuleId: string;
    enterpriseId: string;
}) => {
    const { data } = useRoutingRulesData(routingRuleId);
    const isLegacyRoutingRule = data?.routingRules?.[0]?.triggerType === RoutingRuleTriggerType.Legacy;

    if (isLegacyRoutingRule) {
        return (
            <Redirect
                to="/$currentEnterpriseId/RoutingRule/DetailLegacy/$routingRuleId"
                params={{ routingRuleId, currentEnterpriseId: enterpriseId }}
                search={{ EnterpriseId: enterpriseId }}
            />
        );
    }
    return <RoutingRulesStepsView routingRuleId={routingRuleId} />;
};
